import React from 'react';
import './History.css';

export default function History() {
    return (
        <div className="history-section mb-5" dir="rtl">
            <div className='mb-5'>.</div>
            <div className="container">
                {/* Header Section */}
                <div className="history-header text-center mb-5">
                    <h1 className="history-main-title">رحلة التميز والتطور</h1>
                    <p className="history-subtitle">من ٢٠١٨ وحتى اليوم</p>
                    <div className="header-divider"></div>
                </div>

                {/* Introduction Section */}
                <div className="intro-section mb-6">
                    <div className="row align-items-center">
                        <div className="col-lg-8 mx-auto text-center">
                            <p className="intro-text">
                                بدأنا رحلتنا في عام ٢٠١٨ لتقديم حلول الشاشات التعليمية التفاعلية، ملتزمين بأن نكون شريكًا فاعلاً في تحقيق الرؤية الطموحة لتطوير التعليم في مصر.
                            </p>
                            <p className="intro-text">
                                منذ تأسيس شركتنا، وضعنا هدفًا واضحًا ومحددًا: تسخير التكنولوجيا لتعزيز جودة وفعالية العملية التعليمية.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Timeline Section */}
                <div className="timeline-container">
                    {/* Phase 1 */}
                    <div className="timeline-phase">
                        <div className="phase-card">
                            {/* Timeline Marker */}
                            <div className="timeline-marker">
                                <div className="marker-circle">
                                    <span className="phase-number">٠١</span>
                                </div>
                                <div className="timeline-line"></div>
                            </div>

                            {/* Content */}
                            <div className="phase-content">
                                <div className="phase-period">
                                    <span className="period-badge">٢٠١٨ - ٢٠٢٠</span>
                                </div>
                                <h3 className="phase-title">مرحلة التأسيس والانتشار</h3>
                                
                                <div className="phase-details">
                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-bullseye"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>الهدف</h5>
                                            <p>إدخال تقنية الشاشات التفاعلية إلى الفصول الدراسية كبديل للسبورات التقليدية</p>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-crosshairs"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>التركيز</h5>
                                            <p>إقامة الشراكات الأولية مع المؤسسات التعليمية وتوفير تدريب مكثف للمعلمين على استخدام التكنولوجيا الجديدة</p>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-trophy"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>الإنجازات</h5>
                                            <div className="achievements-list">
                                                <span className="achievement-tag">بني سويف</span>
                                                <span className="achievement-tag">الإسماعيلية</span>
                                                <span className="achievement-tag">أسيوط</span>
                                                <span className="achievement-tag">القاهرة</span>
                                                <span className="achievement-tag">الفيوم</span>
                                                <span className="achievement-tag">المنيا</span>
                                                <span className="achievement-tag">السويس</span>
                                                <span className="achievement-tag">دمياط</span>
                                                <span className="achievement-tag">بورسعيد</span>
                                                <span className="achievement-tag">الأقصر</span>
                                                <span className="achievement-tag">المنوفية</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Phase 2 */}
                    <div className="timeline-phase">
                        <div className="phase-card">
                            {/* Timeline Marker */}
                            <div className="timeline-marker">
                                <div className="marker-circle">
                                    <span className="phase-number">٠٢</span>
                                </div>
                                <div className="timeline-line"></div>
                            </div>

                            {/* Content */}
                            <div className="phase-content">
                                <div className="phase-period">
                                    <span className="period-badge">٢٠٢١ - ٢٠٢٣</span>
                                </div>
                                <h3 className="phase-title">مرحلة التوسع النوعي والتكامل</h3>
                                
                                <div className="phase-details">
                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-bullseye"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>الهدف</h5>
                                            <p>دمج الشاشات التفاعلية مع المنظومة التعليمية بشكل أعمق</p>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-crosshairs"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>التركيز</h5>
                                            <p>تطوير ميزات برمجية تتناسب مع المناهج المطورة ودعم أنماط التعلم النشط والتشاركي</p>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-trophy"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>الإنجازات</h5>
                                            <div className="achievements-list">
                                                <span className="achievement-tag">التطوير ببرامج لتسهيل عملية الشرح للمعلمين</span>
                                                <span className="achievement-tag">أنظمة إدارة التعلم المتكاملة</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Phase 3 */}
                    <div className="timeline-phase">
                        <div className="phase-card">
                            {/* Timeline Marker */}
                            <div className="timeline-marker">
                                <div className="marker-circle">
                                    <span className="phase-number">٠٣</span>
                                </div>
                                <div className="timeline-line"></div>
                            </div>

                            {/* Content */}
                            <div className="phase-content">
                                <div className="phase-period">
                                    <span className="period-badge">٢٠٢٤ - ٢٠٢٥</span>
                                </div>
                                <h3 className="phase-title">مرحلة الابتكار وتعميق الأثر</h3>
                                
                                <div className="phase-details">
                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-bullseye"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>الهدف</h5>
                                            <p>الوصول إلى أقصى استفادة من التكنولوجيا لتقليص الفجوة التعليمية ودعم التعلم الشخصي</p>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-crosshairs"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>التركيز</h5>
                                            <p>تطوير جيل جديد من الشاشات ذات الميزات المتقدمة وتقديم حلول متكاملة لبيئات الفصول الذكية</p>
                                        </div>
                                    </div>

                                    <div className="detail-item">
                                        <div className="detail-icon">
                                            <i className="fas fa-trophy"></i>
                                        </div>
                                        <div className="detail-content">
                                            <h5>الإنجازات</h5>
                                            <div className="achievements-list">
                                                <span className="achievement-tag">دعم تطبيقات الذكاء الاصطناعي في التعليم</span>
                                                <span className="achievement-tag">حلول متكاملة للتعليم الفني والمهني</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Conclusion Section */}
                <div className="conclusion-section mt-6">
                    <div className="conclusion-card">
                        <div className="row align-items-center">
                            <div className="col-lg-2 text-center">
                                <div className="conclusion-icon">
                                    <i className="fas fa-graduation-cap"></i>
                                </div>
                            </div>
                            <div className="col-lg-10">
                                <h4 className="conclusion-title">شاشاتنا التفاعلية: محرك التغيير في الفصل الدراسي</h4>
                                <p className="conclusion-text">
                                    تُعد الشاشات التعليمية التفاعلية التي نقدمها أكثر من مجرد أداة عرض؛ إنها بيئة تعلم متكاملة تدعم محاور تطوير التعليم في مصر، 
                                    وتساهم في خلق تجربة تعليمية غنية ومحفزة للإبداع والابتكار.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}